const scriptjsWrapper = url =>
  import(/* webpackChunkName: "scriptjs" */ 'scriptjs')
    .then(scriptjs => scriptjs.default)
    .then(scriptjs => new Promise(resolve => scriptjs(url, resolve)));
export { scriptjsWrapper };
